import React from 'react';
import { Search } from 'lucide-react';
import { HeroSearchBarProps } from './types';

export function HeroSearchBar({ onOpen }: HeroSearchBarProps) {
  return (
    <form onSubmit={(e) => {
      e.preventDefault();
      onOpen();
    }} className="relative w-full">
      <input
        type="text"
        placeholder="O que você procura?"
        className="w-full pl-12 pr-16 py-4 rounded-full bg-white/90 dark:bg-gray-800 backdrop-blur-[20px] text-gray-900 placeholder-gray-500 dark:placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-teal-500"
        onClick={(e) => {
          e.preventDefault();
          onOpen();
        }}
        readOnly
      />
      <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-6 w-6 text-gray-400" />
      <button
        type="submit"
        className="absolute right-3 top-1/2 transform -translate-y-1/2 px-4 py-2 bg-blue-900 text-white rounded-full hover:bg-blue-950 transition-colors"
      >
        Buscar
      </button>
    </form>
  );
}